import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Paper, Stack, Group } from '@mantine/core'
import { AppText } from '../../../app/common/ui'
import { AppButton } from '@gunslop/ui'
import ArduinoStore from '../../../app/stores/arduinoStore'
import ArduinoValueDisplay from './ArduinoValueDisplay'

interface Props {
  arduinoStore: ArduinoStore;
}

export default function ArduinoList ({ arduinoStore }: Props) {
  const { deleteArduino, arduinos, loading } = arduinoStore
  const [target, setTarget] = useState('')

  function handleArduinoDelete (e: React.MouseEvent<HTMLButtonElement>, id: string) {
    setTarget(e.currentTarget.name)
    deleteArduino(id)
  }

  return (
    <Paper p="md" withBorder>
      <Stack spacing="md">
        {arduinos.map((arduino: { id: string; value: number }) => (
          <Paper key={arduino.id} p="sm" withBorder>
            <AppText weight={600}>Internet of Things</AppText>
            <ArduinoValueDisplay arduinos={arduinos} arduinoId={arduino.id}>
              {arduino.value}
            </ArduinoValueDisplay>
            <Group position="apart" mt="sm">
              <AppButton component={Link} to={`/arduinos/${arduino.id}`} variant="light" size="xs">
                View
              </AppButton>
              <AppButton
                name={arduino.id}
                loading={loading && target === arduino.id}
                onClick={(e) => handleArduinoDelete(e, arduino.id)}
                color="red"
                variant="light"
                size="xs"
              >
                Delete
              </AppButton>
            </Group>
          </Paper>
        ))}
      </Stack>
    </Paper>
  )
}
